// La faccion llega escrita de varias formas segun quien la guardo: 'heroe' (bot de Twitch),
// 'Héroe', 'héroe', 'Villano'... Igual que ClickParticles, manda la primera letra.
// Devuelve 'heroe', 'villano' o '' (neutro).
export const faccionKey = (faccion) => {
    const first = String(faccion || '').trim().toLowerCase().charAt(0);
    return first === 'h' ? 'heroe' : first === 'v' ? 'villano' : '';
};
